import { useEffect, useState, ChangeEvent } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    FormLabel,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import {useFormik, Form, FormikProvider} from 'formik';


// project-imports
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import {Calendar, Camera} from 'iconsax-react';
import useAuth from "../../../hooks/useAuth";
import {MobileDatePicker} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFnsV3";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import * as Yup from "yup";
import { dispatch, useSelector } from 'store';
import { editEmployee, updateProfilePic } from 'store/reducers/employee';
import { getList as getDepartments} from 'store/reducers/hr/department';
import { useParams } from 'react-router-dom';
import { openSnackbar } from 'store/reducers/snackbar';
import Loader from 'components/Loader';



// styles & constant
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        }
    }
};

// ==============================|| ACCOUNT PROFILE - PERSONAL ||============================== //
interface Props {
    isEmployee?: boolean}
const ProfileDetails = ({isEmployee=false}:Props) => {
    const theme = useTheme();
    const [selectedImage, setSelectedImage] = useState<File | undefined>(undefined);
    const [designations, setDesignations] = useState<any >([]);
    const { user } = useAuth();
    const { item ,isLoading} = useSelector((state) => state.employee);
    const { list:departments} = useSelector((state) => state.department);
    const [userDetails, setUserDetails] = useState<any>(isEmployee? item:user);
    const [avatar, setAvatar] = useState<string | undefined|any>(isEmployee? item?.profile_pic:user?.profile_pic);
    const { employee_id } = useParams();
    const [loading, setLoading] = useState<boolean>(false);

    const getDirtyValues = (values:any, initialObject: any): object => {
        const data = { ...values };
        const keyValues = Object.keys(data);

        const dirtyValues = keyValues.filter(
            (keyValue) => data[keyValue] !== initialObject[keyValue],
        );

        keyValues.forEach((key) => {
            if (!dirtyValues.includes(key)) delete data[key];
        });

        return data;
    };

   
    useEffect(() => {
        
        if (selectedImage) {
            setAvatar(URL.createObjectURL(selectedImage));
        }
        
        dispatch(getDepartments());
        if(isEmployee){
            setUserDetails(null);
            setUserDetails(item);
       
           console.log(item);
           setDesignations(item?.department?.designations)
           
        }else{
            setUserDetails(user);
            setDesignations(user?.department?.designations)
        }
        setLoading(true)
    }, [selectedImage]);

    useEffect(()=>{
        if(!isLoading && isEmployee && item){            
            setUserDetails(item);
        }
      },[isLoading,item])
      
    const formik = useFormik({
        enableReinitialize:true,
        initialValues:{
            first_name: userDetails?.first_name?? '',
            last_name: userDetails?.last_name?? '',
            email: userDetails?.email?? '',
            gender: userDetails?.gender?? '',
            date_of_birth: userDetails?.date_of_birth?? '',
            phone_number: userDetails?.phone_number?? '',
            employment_type:userDetails?.employment_type?? '',
            designation_id:userDetails?.designation_id?? ''
        },
        validationSchema:
            Yup.object().shape({
            first_name: Yup.string().required('First name is required'),
            last_name: Yup.string().required('Last name is required'),
            // phone_number: Yup.string().required('Phone numberis required'),
            email:Yup.string().email('Must be a valid email').max(255).required('Email is required'),
        }),

        onSubmit:(values, { setSubmitting,resetForm }) => {
          
            var updatedValues:any=getDirtyValues(values,initialValues);
           
            
            try {
                dispatch(editEmployee(parseInt(employee_id?? '0'),updatedValues)).then(()=>{
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Profile updated successfully.',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: true
                        })
                    );
                   
                })
               
               console.log(item);
               

                resetForm();
           
                setSubmitting(false);
           
            } catch (err: any) {
        
                setSubmitting(false);
            }
        }});
    const {   handleSubmit, getFieldProps,setFieldValue ,initialValues} = formik;
   
    if((!userDetails && !loading) || isLoading) return <Loader/>
  
   
    return (
        <Grid container >
            <FormikProvider value={formik}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Form   onSubmit={handleSubmit}>
            <MainCard title="Personal Information">
            <Grid item xs={12} >
            

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Stack spacing={2.5} alignItems="center" sx={{ m: 3 }}>
                                    <FormLabel
                                        htmlFor="change-avtar"
                                        sx={{
                                            position: 'relative',
                                            borderRadius: '50%',
                                            overflow: 'hidden',
                                            '&:hover .MuiBox-root': { opacity: 1 },
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <Avatar alt="Avatar 1" src={avatar} sx={{ width: 76, height: 76 }} />
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .75)' : 'rgba(0,0,0,.65)',
                                                width: '100%',
                                                height: '100%',
                                                opacity: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            <Stack spacing={0.5} alignItems="center">
                                                <Camera style={{ color: theme.palette.secondary.lighter, fontSize: '1.5rem' }} />
                                                <Typography sx={{ color: 'secondary.lighter' }} variant="caption">
                                                    Upload
                                                </Typography>
                                            </Stack>
                                        </Box>
                                    </FormLabel>
                                    <TextField
                                        type="file"
                                        id="change-avtar"
                                        placeholder="Outlined"
                                        variant="outlined"
                                        disabled={!isEmployee}
                                        sx={{ display: 'none' }}
                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                            
                                            setSelectedImage(e.target.files?.[0]);
                                            dispatch(updateProfilePic(parseInt(employee_id?? '0'),{photo:e.target.files?.[0]})).then(()=>{

                                            })
                                        }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-first-name">First Name</InputLabel>
                                    <TextField fullWidth defaultValue={userDetails?.first_name}  {...getFieldProps('first_name')} id="personal-first-name" placeholder="First Name"  />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-last-name">Last Name</InputLabel>
                                    <TextField fullWidth defaultValue={userDetails?.last_name} id="personal-last-name" {...getFieldProps('last_name')} placeholder="Last Name" />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-email">Email</InputLabel>
                                    <TextField fullWidth defaultValue={userDetails?.email} id="personal-email"  {...getFieldProps('email')} placeholder="Email" />
                                </Stack>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-phone-number">Phone Number</InputLabel>
                                    <TextField fullWidth type={"number"} defaultValue={userDetails?.phone_number} id="personal-phone-number" {...getFieldProps('phone_number')} placeholder="Phone Number" />
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-gender">Gender</InputLabel>
                                    <Select fullWidth id="personal-gender" defaultValue={userDetails?.gender} {...getFieldProps('gender')} onChange={event => {
                                        setFieldValue('gender',event.target.value);
                                    }} MenuProps={MenuProps}>
                                        <MenuItem value="m">Male</MenuItem>
                                        <MenuItem value="f">Female</MenuItem>
                                        <MenuItem value="o">Other</MenuItem>
                                    </Select>
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="personal-gender">Employment Type</InputLabel>
                                    <Select fullWidth id="personal-gender" defaultValue={userDetails?.employment_type} {...getFieldProps('employment_type')} onChange={event => {
                                            setFieldValue('employment_type',event.target.value);
                                    }} MenuProps={MenuProps}>
                                        <MenuItem value="full">Full Time</MenuItem>
                                        <MenuItem value="part">Part Time</MenuItem>
                                        <MenuItem value="other">Other </MenuItem>
                                    </Select>
                                </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="cal-start-date">Birth Date</InputLabel>
                                    <MobileDatePicker
                                        value={ new Date(userDetails?.date_of_birth?? '')}
                                        format="yyyy-MM-dd"
                                        onChange={(date) => {
                                            setFieldValue('date_of_birth',date);
                                        }}
                                        slotProps={{textField:{
                                                id: "cal-start-date",
                                                placeholder:"Start date",
                                                fullWidth:true,
                                                // error:{Boolean( touched.start_date_time && errors.start_date_time)},
                                                // error:{Boolean(touched.start_date_time && errors.start_date_time)},
                                                // helperText={{touched.start_date_time && (errors.start_date_time as String)}},
                                                inputProps:{endAdornment: (
                                                        <InputAdornment position="end">
                                                            <Calendar />
                                                        </InputAdornment>
                                                    )}
                                            }}}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="task-detartment">Department</InputLabel>
                                    <TextField placeholder="Select department" fullWidth select defaultValue={isEmployee? item?.department?.id:user?.department?.id}  {...getFieldProps('department')} onChange={(event:any)=>{
                                        var department=departments.find((element) => element.id == event.target.value)
                                        setDesignations(department?.designations);  
                                    }}>
                                        {departments?.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.department_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Stack>
                            </Grid>
                            <Grid item xs={6}>
                                <Stack spacing={1.25}>
                                    <InputLabel htmlFor="task-detartment">Designation</InputLabel>
                                    <TextField placeholder="Select department" fullWidth select  {...getFieldProps('designation_id')}
                                                >
                                        {designations?.map((option:any) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.designation}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Stack>
                            </Grid>
                        </Grid>
                    
            </Grid>
         
            <Grid item xs={12} style={{display:isEmployee? 'block':'none'}}>
                <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={2}>
                    {/*<Button variant="outlined" color="secondary">
                        Cancel
                    </Button>*/}
                    <Button variant="contained" type='submit'>Update Profile</Button>
                </Stack>
            </Grid>
            </MainCard>
            </Form>
            </LocalizationProvider> 
            </FormikProvider>
        </Grid>
    );
};

export default ProfileDetails;
